<template>
	<div class="vip-detail-wrap">
		<!--<div class="page-header">
			<span class="back"><img src="image/common/center_viptq_ic_back.png" height="48" width="48" alt=""></span>
			<p>VIP会员特权</p>
		</div>-->
		<div class="tab-menu">
			<ul>
				<li :class="{'active':part=='1'}" @click="tabMenu('1')">{{vipInfo.part1.classification}}<span class="line"></span></li>
				<li :class="{'active':part=='2'}" @click="tabMenu('2')">{{vipInfo.part2.classification}}<span class="line"></span></li>
				<li :class="{'active':part=='3'}" @click="tabMenu('3')">{{vipInfo.part3.classification}}<span class="line"></span></li>
			</ul>
		</div>
		<div id="part" class="part">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="item in arr">
						<div>
							<div class="content-box">
								<div class="item-title">
									<img :src="item.privilege_img" alt="">
									<p class="item-title-text">{{item.privilege_name}}</p>
									<p class="item-title-subtext">{{item.privilege_title}}</p>
								</div>
								<div class="item-main">
									<div class="item-content">
										<p class="content-title">
											<img src="../../assets/img/mine/center_vip_pri_ic_su.png" alt=""> 服务用户
										</p>
										<p class="content-text">
											<span v-for="i in item.vip">{{i.vip_name}}</span>
										</p>
									</div>
									<div class="item-content">
										<p class="content-title">
											<img src="../../assets/img/mine/center_vip_pri_ic_soi.png" alt=""> 权益说明
										</p>
										<p class="content-text">
											{{item.privilege_content}}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Add Pagination -->
				<div class="swiper-pagination"></div>
				
			</div>
			<div class="dots"></div>
		</div>
	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.css';
	import Swiper from 'swiper';
	export default{
		name:"vip-detail",
		data(){
			return{
				vid: "",
				part: "",
				index:"",
				vipInfo:{
					part1:"",
					part2:"",
					part3:"",
				},
				arr:"",
			}
		},
		created(){
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.vid = this.$route.query.vid;
			this.part = this.$route.query.part;
			this.index = this.$route.query.index;
			
			this.getBaseInfo();
			
			
		},
		watch:{
				part(n,o){
					let _this = this;
					if(n=='1'){
						this.arr = this.vipInfo.part1.arr;
						_this.initSwiper();
					}else if(n=='2'){
						this.arr = this.vipInfo.part2.arr;
						_this.initSwiper();
					}else if(n=='3'){
						this.arr = this.vipInfo.part3.arr;
						_this.initSwiper();
					}
				}
			},
			methods: {
				initSwiper(i=0){
					console.log(i);
					new Swiper('#part .swiper-container', {
						initialSlide: i,
						slidesPerView: 1.2,
						centeredSlides: true,
						loop: true,
						pagination:{
							el: '#part .dots',
						}
					});
				},
				getBaseInfo(){
					var _this = this;
					this.$axios({
						url:"My/VipDetails",
						method:"post",
						data:{
							v_id:this.vid,
						}
					}).then(res=>{
						if(res.data.code==200){
		  					_this.vipInfo.part1 = res.data.data[0];
		  					_this.vipInfo.part2 = res.data.data[1];
		  					_this.vipInfo.part3 = res.data.data[2];
		  					_this.arr = res.data.data[_this.part-1].arr
		  					var i = parseInt(_this.index);
		  					setTimeout(function(){
		  						_this.initSwiper(i);
		  					},300)
		  				}
					}).catch(err=>{
						console.log(err)
					})
			  		
				},
				tabMenu(p){
					let _this = this;
					this.part = p;
					setTimeout(function(){
						_this.initSwiper(p,0)
					},300)
					
				}
			}
	}
</script>

<style scoped>
	.vip-detail-wrap{background:#202020;width: 100vw;height: 100vh;}
	.page-header{position:relative;}
	.page-header .back{position:absolute;top:0.5rem;left:0.5rem;}
	.page-header .back img{width:2rem;height:auto;}
	.page-header p{font-size:1rem;text-align:center;font-weight:bold;color:rgba(40,40,56,1);line-height:2.75rem;background:linear-gradient(0deg,rgba(255,219,178,1) 0%,rgba(235,177,110,1) 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
	.swiper-container{padding-top:3rem;width:100%;height:calc(100vh - 8rem);position:relative;overflow:initial;overflow-x:hidden;}
	.swiper-slide{text-align:center;font-size:18px;display:-webkit-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;}
	.swiper-slide>div{width:100%;border-radius:0.6rem;overflow:hidden;height:100%;transition:300ms;display:flex;justify-content:center;align-items:center;}
	.swiper-slide .content-box{width:90%;height:90%;transition:300ms;border-radius:0.6rem;overflow:hidden;background:#fff;box-shadow:0px 16px 24px 0px rgba(233,194,151,0.2);padding-bottom:1rem}
	.swiper-slide.swiper-slide-active .content-box{width:100%;height:100%;transition:300ms;}
	.swiper-slide img{width:100%;display:block;}
	.swiper-slide .item-title{text-align:center;background:linear-gradient(90deg,rgba(255,219,178,1) 0%,rgba(235,177,110,1) 100%);padding:1.5rem 0;}
	.swiper-slide .item-title img{width:3.8rem;display:inline-block;border-radius:50%;background: #fff;padding: 0.5rem;box-sizing: border-box;}
	.swiper-slide .item-title-text{font-size:1.1rem;font-weight:bold;color:#fff;line-height:2rem;}
	.swiper-slide .item-title-subtext{font-size:0.9rem;color:#fff;}
	.swiper-slide .item-main{padding:0.7rem 0 0.3rem;}
	.swiper-slide .item-content{padding:0.2rem 1rem;text-align:left;}
	.swiper-slide .item-content span{padding:0 0.2rem;}
	.swiper-slide .content-title{display:flex;justify-content:flex-start;align-items:center;font-size:1rem;color:#282828;font-weight:bold;padding:0.5rem 0;}
	.swiper-slide .content-title img{width:1.6rem;margin-right:0.5rem;}
	.swiper-slide .content-text{font-size:0.9rem;color:#282828;line-height:1.5rem;margin:0.3rem 0;/*display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;*/}
	.dots{width:100%;display:flex;justify-content:center;align-items:center;margin-top:1.5rem;}
	.dots >>>.swiper-pagination-bullet{width:6px;height:6px;border-radius:50%;background:#7b7b7b;margin:0.5rem 0.2rem;opacity:1;}
	.dots >>>.swiper-pagination-bullet-active{width:15px;border-radius:5px;background:#e9c297;}
	.tab-menu ul{display:flex;justify-content:space-between;align-items:center;}
	.tab-menu ul li{flex:1;height:4rem;color:#fff;font-weight:500;text-align:center;line-height:4rem;font-size:1rem;background:none;opacity:1;transition:300ms;font-weight:bold;}
	.tab-menu ul li .line{transition:300ms;}
	.tab-menu ul li.active{font-weight:bold;color:rgba(40,40,56,1);background:linear-gradient(0deg,rgba(255,219,178,1) 0%,rgba(235,177,110,1) 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;position:relative;}
	.tab-menu ul li.active .line{width:50%;height:2px;background:#e9c297;display:inline-block;position:absolute;left:25%;bottom:0;}
</style>


// WEBPACK FOOTER //
// src/components/Mine/VipDetail.vue